import { ITipoIdentificacion, ITipoPersona } from "../../ioip/sdk/base";
import { defaultIContactoExtended, IContactoExtended } from "../../classes/contacto-extended";
import { IChoiceGroupOption, IComboBoxOption } from "@fluentui/react";
import { ICity, ICountry, IDepartment } from "@ioip/archivox/lib";

export interface ICreateContactComponentState {
    model: IContactoExtended;
    errors: { [ key: string ]: string };
    isSaving: boolean;
    autorizaTratamientoDatosPersonales: boolean;
    autorizaPoliticaPrivacidad: boolean;
    tiposIdentificacion: ITipoIdentificacion[];
    tiposIdentificacionCO: IComboBoxOption[];
    tiposIdentificacionCOApoderado: IComboBoxOption[];
    paises: ICountry[];
    paisesCO: IComboBoxOption[];
    departamentos: IDepartment[];
    departamentosCO: IComboBoxOption[];
    ciudades: ICity[];
    ciudadesCO: IComboBoxOption[];
    preguntas: IComboBoxOption[];
    generos: IComboBoxOption[];
    gruposEtnicos: IComboBoxOption[];
    discapacidades: IComboBoxOption[];
    atencionPreferencial: IComboBoxOption[];
    tiposPersona: ITipoPersona[];
    tiposPersonaCO: IComboBoxOption[];
    nivelEducativo: IComboBoxOption[];
    profesiones: IComboBoxOption[];
    mostrarProfesion: boolean;
    tiposSolicitante: IComboBoxOption[];
    mostrarTipoSolicitante: boolean;
    mostrarPanelPoliticaDatos: boolean;
    opcionesSeleccionGrupo: IChoiceGroupOption[];
}

export function defaultCreateContactComponentState(): ICreateContactComponentState {
    return {
        model: defaultIContactoExtended(),
        errors: {},
        isSaving: false,
        autorizaPoliticaPrivacidad: false,
        autorizaTratamientoDatosPersonales: false,
        ciudades: [],
        ciudadesCO: [],
        departamentos: [],
        departamentosCO: [],
        paises: [],
        paisesCO: [],
        tiposIdentificacion: [],
        tiposIdentificacionCO: [],
        tiposIdentificacionCOApoderado: [],
        preguntas: [],
        generos: [],
        gruposEtnicos: [],
        discapacidades: [],
        atencionPreferencial: [],
        tiposPersona: [],
        tiposPersonaCO: [],
        nivelEducativo: [],
        profesiones: [],
        mostrarProfesion: true,
        tiposSolicitante: [],
        mostrarTipoSolicitante: false,
        mostrarPanelPoliticaDatos: true,
        opcionesSeleccionGrupo: [
            {
                key: '0',
                text: 'No',
            },
            {
                key: '1',
                text: 'Sí',
            }
        ],
    }
}